import React from 'react';
import ThanksLeft from 'assets/thanks-left.png';
import ThanksRight from 'assets/thanks-right.png';
import ThanksArrow from 'assets/thanks-arrow-sp.png';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import { THANKS_TEXT } from 'utils/constant';

import './index.sp.scss';

const PresentSP = ({ onClickMainButton, lpMode }) => {
  const { Orei, BoxTitle, leftSubTitle, leftDetail, leftAnnotationText, leftAsteriskText,
    rightSubTitle, rightDetail, rightAnnotationText } = THANKS_TEXT;
  const DispText = (text) => {
    return Array.isArray(text) 
      ? text.map(line => {
        return(
          <div key={line} className="">
            {line}
          </div>
        );
      })
      : <>{text}</>;
  };

  return(

    <div className="SpThanks">
      <SpBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        lpMode={lpMode}
      >
        <div className="SpOrei">
          {DispText(Orei)}
        </div>
      
        <div className="kongoBox Container">
          <span className="BoxTitle">{DispText(BoxTitle)}</span>

          <div className="SpLeftContent ContainerUtemLeft LeftContainerTop">
            <div className="SpLeftImagebox LeftContainerTopLeft">
              <img className="SpLeftImage" src={ThanksLeft} alt="image1" />
            </div>
            <div className="LeftContainerTopRight">
              <div className="SubTitle">
                {DispText(leftSubTitle)}
              </div>
              <div className="detailText">
                <div className="detailTitle">
                  {DispText(leftDetail)}
                </div>
                <div className="annotationText">
                  {DispText(leftAnnotationText)}
                  {DispText(leftAsteriskText)}
                </div>
              </div>
            </div>
          </div>

          <div className="SpCenterContent ContainerUtemCenter">
            <img className="SpArrowImage" src={ThanksArrow} alt="arrow" />
          </div>

          <div className="SpRightContent ContainerUtemRight RightContainerBottom">
            <div className="SpRightImagebox RightContainerBottomLeft">
              <img className="SpRightImage" src={ThanksRight} alt="image2" />
            </div>
            <div className="RightContainerBottomRight">
              <div className="SubTitle">
                {DispText(rightSubTitle)}
              </div>
              <div className="detailText">
                <div className="detailTitle">
                  {DispText(rightDetail)}
                </div>
                <div className="annotationText">
                  {DispText(rightAnnotationText)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SpBasicTemplate>
    </div>
  );
};
  
  
export default PresentSP;